<div class="chat-container" *ngIf="useridold == 0 && perfil.ID != misdatos.ID && !showModal" data-bs-toggle="modal" data-bs-target="#mensajesModal" (click)="showModal = true;" role="button" tabindex="0" aria-label="Abrir conversación" (keydown.enter)="showModal = true;">
  <div class="chat-bubble">
    <i class="fa-solid fa-comments chat-bubble-fallback" *ngIf="!perfil?.foto?.foto_principal_thumb" aria-hidden="true"></i>
    <img
      *ngIf="perfil?.foto?.foto_principal_thumb"
      [src]="perfil?.foto?.foto_principal_thumb"
      class="rounded-circle chat-float-avatar"
      width="52" height="52"
      [style.zIndex]="1">
  </div>
  <div class="chat-label text-center">
    ¿Hablamos?
    <div class="small text-success" *ngIf="perfil.online">Estoy en línea</div>
  </div>
</div>

<!-- Modal -->
<div class="modal fade" id="mensajesModal" tabindex="-1" aria-labelledby="mensajesModalLabel" aria-hidden="true" data-bs-keyboard="false">
  <div class="modal-dialog modal-lg modal-dialog-centered mensajes-dialog">
    <div class="modal-content mensajes-content">
      <!--*******************************************************************************-->
      <!--MOSTRAR MENSAJES CON UN PERFIL-->
      <div *ngIf="misdatos && (misdatos | keyvalue)?.length && userid != misdatos.ID">
        <!--PERFIL-->
        <app-perfil-mensaje [perfil]="perfil" [botones]="true"></app-perfil-mensaje>
        <div class="modal-body">
          <div
            #scrollContainer
            (scroll)="onScroll($event)"
            class="p-3 rounded justify-content-end bg-page-body mensajes-scroll"
            >
            <div *ngIf="mensajes.length == 0 && loadMensajes" class="small">
              ¡Rompe el hielo con <b>{{perfil.first_name | firstWord}}</b>!
              <br>
              Envía un mensaje para iniciar el chat. Recuerda ser siempre respetuoso y disfrutar de la conversación.
            </div>
            <div *ngFor="let mensaje of mensajes">
              <!--Mensajes del otro usuario-->
              <div *ngIf="misdatos.ID == mensaje.me_us_id_to" class="mb-3">
                <div class="row">
                  <div class="col-auto">
                    <div class="d-flex w-100 align-content-center">
                      <div class="me-2">
                        <img *ngIf="mensaje.foto.foto_principal_thumb" width="35px"
                            [src]="mensaje.foto.foto_principal_thumb" 
                            class="rounded-circle pointer thumb-popup" alt="Foto de perfil"
                            [attr.data-full]="mensaje.foto.foto_principal_grande">
                      </div>
                      <div class="w-100 text-secondary">
                        {{mensaje.first_name | firstWord}}
                        <div class="text-secondary small">
                          {{mensaje.cuando}}
                          <span *ngIf="!mensaje.me_leido" class="text-success fw-bold">nuevo</span>
                        </div>
                      </div>
                    </div>
                    <div class="text-start bg-white rounded p-3 chat-left" *ngIf="mensaje.me_us_borrado == 0">
                      <div *ngIf="mensaje.fotos.length == 0">
                        <div [innerHTML]="formatEmojiImages(mensaje.me_mensaje)"></div>
                      </div>                        
                      <img *ngFor="let foto of mensaje.fotos"
                          [src]="foto.foto_principal_thumb" 
                          class="rounded pointer thumb-popup me-1" alt="Foto" width="70px"
                          [attr.data-full]="foto.foto_principal_grande"
                          (load)="scrollToBottom()">
                    </div>
                    <!--MENSAJE BORRADO-->
                    <div class="text-start" *ngIf="mensaje.me_us_borrado != 0"><span class="badge badge-light-gray">mensaje borrado</span></div>
                  </div>
                  <div class="col ps-5"></div>
                </div>
              </div>
              <!--Mis mensajes-->
              <div *ngIf="misdatos.ID != mensaje.me_us_id_to" class="mb-3">
                <div class="d-flex w-100 align-items-center text-end justify-content-center">
                  <div class="w-100 text-secondary">
                    {{mensaje.first_name | firstWord}}
                    <div class="text-secondary small">
                      {{mensaje.cuando}}
                    </div>
                  </div>
                  <div class="ms-2">
                    <img *ngIf="mensaje.foto.foto_principal_thumb" width="35px"
                        [src]="mensaje.foto.foto_principal_thumb" 
                        class="rounded-circle pointer thumb-popup" alt="Foto de perfil"
                        [attr.data-full]="mensaje.foto.foto_principal_grande">
                  </div>
                  <div class="dropdown" *ngIf="mensaje.me_us_borrado == 0">
                    <i class="fa-solid fa-ellipsis-vertical pointer p-1" data-bs-toggle="dropdown" aria-expanded="false"></i>
                    <ul class="dropdown-menu">
                      <li><a class="dropdown-item pointer" (click)="copiarMensaje(mensaje)"><i class="fa-regular fa-copy"></i> Copiar</a></li>
                      <li><a class="dropdown-item pointer" (click)="borrarMensaje(mensaje)"><i class="fa-regular fa-trash-can"></i> Borrar</a></li>
                    </ul>
                  </div>                      
                </div>
                <div class="row justify-content-end">
                  <div class="col-2"></div>
                  <div class="col-auto" style="max-width: 80%;">
                    <div class="text-start bg-iguau text-white rounded p-3 chat-right" *ngIf="mensaje.me_us_borrado == 0">
                      <div *ngIf="mensaje.fotos.length == 0">
                        <div [innerHTML]="formatEmojiImages(mensaje.me_mensaje)"></div>
                      </div>                        
                      <img *ngFor="let foto of mensaje.fotos"
                          [src]="foto.foto_principal_thumb" 
                          class="rounded pointer thumb-popup me-1" alt="Foto" width="70px"
                          [attr.data-full]="foto.foto_principal_grande"
                          (load)="scrollToBottom()">
                    </div>
                    <!--MENSAJE BORRADO-->
                    <div class="text-end" *ngIf="mensaje.me_us_borrado != 0"><span class="badge badge-light-gray">mensaje borrado</span></div>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="!loadMensajes" class="text-secondary">
              <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
              Obteniendo mensajes... 
            </div>
            <div *ngIf="enviando && scrollToBottom()" class="text-secondary">
              <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
              Enviando mensaje... 
            </div>
          </div>
          <!--ENVIAR MENSAJES-->
          <div class="mensajes-compose" [hidden]="!loadMensajes">
            <div class="mensajes-adjuntos" *ngIf="nuevomensaje.imagenes.length > 0">
              <div class="mensajes-adjuntos-head">
                <div class="mensajes-adjuntos-title">
                  <i class="fa-regular fa-image"></i>
                  {{ nuevomensaje.imagenes.length }} adjunto<span *ngIf="nuevomensaje.imagenes.length > 1">s</span>
                </div>
                <button type="button" class="btn btn-link mensajes-adjuntos-clear" (click)="limpiarAdjuntos()">
                  Quitar todo
                </button>
              </div>
              <div class="mensajes-adjuntos-grid">
                <div class="adjunto-item" *ngFor="let imagen of nuevomensaje.imagenes; let i = index">
                  <button type="button" class="adjunto-preview-button" (click)="abrirPreview(i)" [attr.aria-label]="'Ampliar imagen ' + (i + 1)">
                    <img [src]="imagen.preview || imagen.data" alt="Adjunto {{ i + 1 }}">
                  </button>
                  <button type="button" class="adjunto-remove" (click)="eliminarAdjunto(i)" aria-label="Eliminar adjunto">
                    <i class="fa-solid fa-xmark"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="iguau-private-picker" *ngIf="mostrarAlbumPrivado" role="dialog" aria-label="Seleccionar fotografía privada">
              <div class="iguau-private-head"><strong><i class="fa-solid fa-lock"></i> Mis fotos privadas</strong>
                <button type="button" aria-label="Cerrar álbum" (click)="mostrarAlbumPrivado = false"><i class="fa-solid fa-xmark"></i></button>
              </div>
              <p class="iguau-private-explain">La foto seleccionada se enviará al destinatario del chat. La original seguirá siendo privada en tu álbum.</p>
              <p *ngIf="cargandoAlbumPrivado">Cargando tus fotografías...</p>
              <p *ngIf="errorAlbumPrivado" class="text-danger">{{errorAlbumPrivado}}</p>
              <p *ngIf="!cargandoAlbumPrivado && !errorAlbumPrivado && !fotosPrivadas.length">Todavía no tienes fotografías privadas.</p>
              <div class="iguau-private-grid" *ngIf="fotosPrivadas.length">
                <button type="button" *ngFor="let foto of fotosPrivadas" (click)="adjuntarPrivada(foto)" [disabled]="foto.adjuntando" [title]="foto.ft_titulo || 'Adjuntar foto'">
                  <img *ngIf="foto.miniUrl" [src]="foto.miniUrl" alt="Fotografía privada">
                  <span *ngIf="!foto.miniUrl" class="iguau-private-placeholder"><i class="fa-regular fa-image"></i></span>
                  <small>{{foto.adjuntando ? 'Preparando...' : (foto.ft_titulo || 'Sin título')}}</small>
                </button>
              </div>
            </div>
            <div class="mensajes-photo-viewer" *ngIf="previewAdjuntoIndex !== null" (click)="cerrarPreview()" role="dialog" aria-modal="true" aria-label="Vista previa de imagen">
              <button type="button" class="mensajes-photo-close" (click)="cerrarPreview()" aria-label="Cerrar vista previa"><i class="fa-solid fa-xmark"></i></button>
              <img [src]="nuevomensaje.imagenes[previewAdjuntoIndex]?.preview || nuevomensaje.imagenes[previewAdjuntoIndex]?.data"
                   alt="Imagen adjunta ampliada" (click)="$event.stopPropagation()">
            </div>

            <div class="emoji-picker-container position-relative mensajes-compose-box" [class.is-drag-over]="arrastrandoArchivos"
                 (dragenter)="onDragEnter($event)" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDropImagenes($event)">
              <div class="mensajes-drop-hint" *ngIf="arrastrandoArchivos" aria-hidden="true">
                <i class="fa-solid fa-images"></i><span>Suelta las imágenes para adjuntarlas</span>
              </div>
              <div class="mensajes-tools" aria-label="Herramientas del mensaje">
                <button type="button" class="mensajes-attach" (click)="alternarAdjuntos($event)" title="Adjuntar fotografía" aria-label="Opciones para adjuntar fotografía">
                  <i class="fa-solid fa-paperclip"></i>
                  <span class="attach-count" *ngIf="nuevomensaje.imagenes.length > 0">{{ nuevomensaje.imagenes.length }}</span>
                </button>
                <div class="iguau-attach-menu" *ngIf="mostrarAdjuntarOpciones" (click)="$event.stopPropagation()">
                  <button type="button" (click)="onClickImagen(); mostrarAdjuntarOpciones = false"><i class="fa-regular fa-image"></i> Elegir del dispositivo</button>
                  <button type="button" (click)="abrirAlbumPrivado()"><i class="fa-solid fa-lock"></i> Mis fotos privadas</button>
                </div>
                <button type="button" class="mensajes-emoji-trigger" aria-label="Elegir emoji" title="Emojis"
                        [attr.aria-expanded]="dropdownOpen" (click)="toggleDropdown($event)">
                  <i class="fa-regular fa-face-smile"></i>
                </button>
                <input
                  type="file"
                  multiple
                  #fileInputMensajes
                  accept="image/*"
                  style="display: none"
                  (change)="onFileSelected($event)"
                />
                <div class="mensajes-emoji-panel" *ngIf="dropdownOpen" (click)="$event.stopPropagation()">
                  <span class="mensajes-emoji-title">Añadir emoji</span>
                  <div class="mensajes-emoji-grid">
                    <button type="button" *ngFor="let emoji of emojis" (click)="seleccionarEmoji(emoji)"
                            [attr.aria-label]="'Añadir emoji ' + emoji">{{emoji}}</button>
                  </div>
                </div>
              </div>

              <div class="mensajes-input-wrap">
                <textarea
                  #mensajeTextarea
                  autoResize
                  #autoResize="autoResize"
                  [maxChars]="250"
                  [maxlength]="250"
                  class="form-control mensajes-textarea"
                  rows="1"
                  placeholder="{{misdatos.first_name | firstWord}}, escribe un mensaje..."
                  [(ngModel)]="mensaje"
                  (keydown.enter)="onEnter($event)"
                  [disabled]="enviando">
                </textarea>
                <div class="mensajes-input-meta">
                  <span class="input-hint" *ngIf="!enviando">Enter para enviar</span>
                  <span class="input-counter">{{ (mensaje || '').length }}/250</span>
                </div>
              </div>

              <button type="button" class="btn btn-primary mensajes-send" (click)="enviarMensaje()" [disabled]="enviando || !puedeEnviar">
                <i class="fa-solid fa-paper-plane"></i>
                <span>Enviar</span>
              </button>
            </div>
            <p class="mensajes-drop-note"><i class="fa-solid fa-images" aria-hidden="true"></i> También puedes arrastrar y soltar fotos aquí para adjuntarlas.</p>
          </div>
        </div>
      </div>
      <!--*******************************************************************************-->
      <!--MOSTRAR PERFILES CON LOS QUE HAY MENSAJES-->
      <div *ngIf="misdatos && (misdatos | keyvalue)?.length && userid == misdatos.ID">
        <div class="modal-body">
          <div class="titulo-modulo">Mensajes</div>
          <div
            #scrollContainer
            class="p-2 rounded justify-content-end mensajes-list">
            <div *ngFor="let perfil of perfilesMensajes" class="mb-2" (click)="seleccionarPerfil(perfil)">
              <app-perfil-mensaje [perfil]="perfil"></app-perfil-mensaje>
              <div class="m-2 border-bottom"></div>
            </div>
            <div *ngIf="!loadMensajes" class="text-secondary">
              <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
              Obteniendo mensajes... 
            </div>
          </div>
          <div class="row mt-3">
            <div class="col"></div>
            <div class="col-auto">
              <button type="button" class="btn btn-secondary btn-sm w-100" data-bs-dismiss="modal">Cerrar</button>
            </div>
          </div>
        </div>
      </div>
      <!--*******************************************************************************-->
      <!--CARGANGO MENSAJES-->
      <div *ngIf="!(misdatos | keyvalue)?.length">
        <div class="modal-body">
          <div class="titulo-modulo">Mensajes</div>
          <div
            #scrollContainer
            class="p-2 rounded justify-content-end mensajes-list">
            <div *ngFor="let perfil of perfilesMensajes" class="mb-2" (click)="seleccionarPerfil(perfil)">
              <app-perfil-mensaje [perfil]="perfil"></app-perfil-mensaje>
            </div>
            <div *ngIf="!loadMensajes" class="text-secondary">
              <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
              Obteniendo mensajes... 
            </div>
          </div>
          <div class="row mt-3">
            <div class="col"></div>
            <div class="col-auto">
              <button type="button" class="btn btn-secondary btn-sm w-100" data-bs-dismiss="modal">Cerrar</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
